<div id="control-background">
  <nav>
    <img class="logo" src="../../assets/images/logo1.png">
    <div class="menu">
      <span></span>
      <ul>
        <li><a (click)="routerService.GoToSetting(id)">設定</a></li>
        <li><a (click)="routerService.GoToControl(id)">控制</a></li>
        <li><a (click)="routerService.GoToOverview(id)">播放清單</a></li>
        <li><a (click)="routerService.GoToLottery(id)">抽獎</a></li>
      </ul>
    </div>
  </nav>
  <div id="control-screen" *ngIf="checkIDState === 1">
    <header>
      控制頁面
    </header>
    <div id="content">
      <div class="donate-content">
        <div class="donateshow" *ngIf="donateState === 1 && !isSecondPatronTurn">
          <!-- <img src="https://i.imgur.com/MMZ2TvB.jpg" id="patron" /> -->
          <!-- <img src="https://i.imgur.com/iFzdRgk.jpeg" id="patron"> -->
          <img src={{currentDonate.pic1}} id="patron">
        </div>
        <div class="donateshow" *ngIf="donateState === 1 && isSecondPatronTurn">
          <img src={{currentDonate.pic2}} id="patron">
        </div>

        <div class="donateshow" *ngIf="donateState === 2">
          <img src="{{ settingData.img4 }}" id="donate-img" />
          <div class="donate-text">
            非常感謝 <span id="money">  {{ currentDonate.name }} </span>贊助
            <span id="money">{{ currentDonate.donate }}</span> 元!!
          </div>
          <div class="donate-text">{{ currentDonate.msg }}</div>
        </div>

        <div *ngIf="donateState === 3">
          <div id="youtube">
            <youtube-player [videoId]="yid" (ready)="savePlayer($event)" (change)="onStateChange($event)"
              [playerVars]="playerVars">
            </youtube-player>
          </div>
        </div>
      </div>
      <div class="donate-test-content" *ngIf="settingData">
        <div id="title">Donate 測試表單</div>
        <div class="sponsor-data">
          <dl class="spd-box sb-platform">
            <dd>
              <mat-form-field id="testName">
                <mat-label>你的名字</mat-label>
                <input matInput type="text" [(ngModel)]="testName" name="DonateNickName" />
                <mat-hint align="start">Leave blank to be Anonymous</mat-hint>
              </mat-form-field>
            </dd>
          </dl>
          <dl class="spd-box sb-price">
            <dd>
              <mat-form-field class="example-form-field">
                <mat-label>想要贊助實況主多少錢</mat-label>
                <input matInput type="number" (input)="endTime()" [(ngModel)]="testDonate" name="DonateAmount"
                  id="donateAmount" />
                <!-- <mat-icon matSuffix svgIcon="custom-svg:angular"></mat-icon> -->
                <mat-hint align="start">Minimum: {{ settingData.min_money }}$</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="fill" id="currency">
                <mat-label>幣種</mat-label>
                <mat-select>
                  <mat-option value="TWD">新臺幣</mat-option>
                </mat-select>
              </mat-form-field>
            </dd>
          </dl>
          <dl class="spd-box sb-msg">
            <dd>
              <mat-form-field>
                <mat-label>贊助訊息</mat-label>
                <textarea [(ngModel)]="testMsg" matInput #msglength cdkTextareaAutosize cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="5" name="DonateMsg" id="donatemsg"></textarea>
                <mat-hint align="end">{{ msglength.value.length }} / 100</mat-hint>
              </mat-form-field>
            </dd>
          </dl>
          <dl class="spd-box sb-msg" id="sendyt">
            <dd>
              <mat-form-field style="width: 70%;">
                <mat-label>Youtube影片網址</mat-label>
                <textarea [(ngModel)]="testYt" matInput #test cdkTextareaAutosize cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="5" (keyup)="onkeyupYT($event)" name="yt"></textarea>
                <mat-hint align="start">分享Youtube影片到實況</mat-hint>
              </mat-form-field>
            </dd>
          </dl>
          <dl>
            <dd>
              <div>
                <mat-form-field *ngIf="!testYid" appearance="none" id="starttime1">
                  <input matInput type="text" disabled id="starttime" />
                  <mat-hint>開始時間(秒)</mat-hint>
                </mat-form-field>
                <mat-form-field *ngIf="testYid" appearance="none" id="starttime1">
                  <input matInput placeholder="秒數" type="number" min="0" (input)="endTime()" id="starttime" name="starttime"
                    [(ngModel)]="testStime" />
                  <mat-hint>開始時間(秒)</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="none" id="endtime1">
                  <input matInput type="text" disabled id="endtime" value="{{ testEndtime }}" />
                  <mat-hint>結束時間(秒)</mat-hint>
                </mat-form-field>
              </div>
            </dd>
          </dl>
          <button id="sendbtn" type="submit" (click)="sendTestDonate()" mat-raised-button color="primary">
            donate測試
          </button>
        </div>
      </div>
      <div id="videocontrol">
        <div class="videobutton">
          <button mat-icon-button (click)="previous()">
            <mat-icon>skip_previous</mat-icon>
          </button>
          <button mat-icon-button *ngIf="play === false" (click)="playvideo()">
            <mat-icon>play_arrow</mat-icon>
          </button>
          <button mat-icon-button *ngIf="play === true" (click)="pausevideo()">
            <mat-icon>pause</mat-icon>
          </button>
          <button mat-icon-button (click)="next()">
            <mat-icon>skip_next</mat-icon>
          </button>
          <button mat-button (click)="playend()">播到底</button>
          <div id="volumecontrol">
            <mat-icon id="volumeicon">volume_up</mat-icon>
            <mat-slider thumbLabel [displayWith]="volumetext" (change)="onVolumeChange(volume)" color="primary"
              [(ngModel)]="volume" min="0" max="100">
            </mat-slider>
            <mat-icon id="voiceVolumeicon">record_voice_over</mat-icon>
            <mat-slider thumbLabel [displayWith]="voiceVolumetext" (change)="onVoiceVolumeChange(voiceVolume)"
              color="primary" [(ngModel)]="voiceVolume" min="0" max="100">
            </mat-slider>
          </div>
          <mat-checkbox color="primary" aria-describedby="test" [(ngModel)]="isLoop" id="isloop"
            (change)="onIsLoopChange()">是否循環撥放影片至抖內時間結束</mat-checkbox>
        </div>
      </div>
      <span id="lefttime">{{ videoTimeLeft }} Seconds Left....</span>
      <span id="email">
        <mat-icon id="emailicon">email</mat-icon>
        <span>: support@hibiki-rain.com</span>
      </span>
      <!-- <mat-paginator
                      [length]="paginatorLength"
                      [pageSize]="paginatorPageSize"> -->
      <mat-table #table [dataSource]="donateList" id="donatelist" class="mat-elevation-z8">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> 贊助人 </mat-header-cell>
          <mat-cell #index class="{{ i === pos ? 'current' : '' }}" *matCellDef="let element; index as i"
            (click)="find(i)">
            {{ element.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="donate">
          <mat-header-cell *matHeaderCellDef> 金額 </mat-header-cell>
          <mat-cell class="{{ i === pos ? 'current' : '' }}" *matCellDef="let element; index as i" (click)="find(i)">
            {{ element.donate }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="time">
          <mat-header-cell *matHeaderCellDef> 影片時間 </mat-header-cell>
          <mat-cell class="{{ i === pos ? 'current' : '' }}" *matCellDef="let element; index as i" (click)="find(i)">
            {{ element.time }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="msg">
          <mat-header-cell *matHeaderCellDef> 訊息 </mat-header-cell>
          <mat-cell class="{{ i === pos ? 'current' : '' }}" *matCellDef="let element; index as i" (click)="find(i)">
            {{ element.msg }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <!-- </mat-paginator> -->

      <!-- <input type="number" [(ngModel)]="name" />
      <input type="number" [(ngModel)]="donate" />
      <input type="number" [(ngModel)]="msg" /> -->
      <!-- <button (click)="find()"> 從第幾首開始播</button> -->
    </div>
  </div>
</div>
